'use client'

import { useEffect } from 'react'
import { Loader } from '@vinted/web-ui'
import { useIsClient } from 'usehooks-ts'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import useHelpCenterSessionTracking from '@marketplace-web/help-center/help-center-session-tracking-util'

import { TrackingChannel } from '@marketplace-web/help-center/help-center-faq-entry-url-data'
import {
  transformFaqEntrySearchResponse,
  searchFaqEntries,
} from '@marketplace-web/help-center/help-center-search-data'
import { helpcenterLegacySearchScreenView } from '@marketplace-web/help-center/help-center-home-data'

import { HelpCenterFaqEntry } from '@marketplace-web/help-center/help-center-faq-entry-feature'

// TODO: consider replacing with: api/v2/faq_entries/answer_not_found
const ANSWER_NOT_FOUND_ID = 210

type Props = {
  searchText: string
}

const HelpCenterFaqSearch = ({ searchText }: Props) => {
  const isClientSideRenderReady = useIsClient()
  const { track } = useTracking()
  const { helpCenterSessionId } = useHelpCenterSessionTracking()

  useEffect(() => {
    if (!helpCenterSessionId) return

    track(
      helpcenterLegacySearchScreenView({
        helpCenterSessionId,
      }),
    )
  }, [helpCenterSessionId, track])

  const {
    fetch: fetchFaqSearchResults,
    transformedData: searchData = null,
    isLoading: isFaqSearchLoading,
  } = useFetch(searchFaqEntries, transformFaqEntrySearchResponse)

  useEffect(() => {
    fetchFaqSearchResults(searchText)
  }, [searchText, fetchFaqSearchResults])

  if (isFaqSearchLoading || !isClientSideRenderReady) {
    return (
      <div
        data-testid="faq-search-loader"
        className="u-flexbox u-justify-content-center u-align-items-center"
      >
        <Loader size="x-large" />
      </div>
    )
  }

  return (
    <div id="faq-container">
      <HelpCenterFaqEntry
        channel={TrackingChannel.Search}
        faqEntryBody={null}
        faqEntryDto={null}
        answerNotFoundId={ANSWER_NOT_FOUND_ID}
        faqQuestions={searchData}
        faqRecommendedQuestions={null}
        faqRelatedQuestions={null}
        infoBoxBody={null}
        transaction={null}
      />
    </div>
  )
}

export default HelpCenterFaqSearch
